

















































































































import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { mixins } from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import ApiStatusMixin from '@/mixins/api-status';
import ApiErrorMixin from '@/mixins/api-error';
import { postAdminLogin } from '@/configs/api-path';
import { ProjectMenu } from '@/models/project';
import { UserLogin } from '@/models/user';
import { encryptSha1 } from '@/utils/crypto';
import getCookieName from '@/utils/cookie';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';

const SECRET_SALT = process.env.VUE_APP_SECRET_SALT;

@Component
export default class PageAuthLogin extends mixins(ApiStatusMixin, ApiErrorMixin) {
  loginForm: {
    projectId: number | null;
    mobile: string | null;
    password: string | null;
  } = {
    projectId: null,
    mobile: null,
    password: null,
  };

  get projectOptions(): Array<{
    label: string;
    code: string | number | null;
  }> {
    return [
      {
        code: null,
        label: '請選擇',
      },
      {
        label: '管理人員',
        code: 0,
      },
      ...this.menuProjects
        .map((project: ProjectMenu) => ({
          code: project.id,
          label: project.name,
        })),
    ];
  }

  get processing() {
    return this.isApiLoading;
  }

  get hasSessionMessage() {
    return Boolean(this.sessionMessage);
  }

  @Getter('app/getMenuProjectsLastest') menuProjects!: ProjectMenu[];

  @Getter('app/getSessionMessage') sessionMessage!: string;

  async loginSubmit() {
    const appModule = getModule(AppModule, this.$store);
    appModule.clearSessionMessage();

    this.setApiLoading();
    try {
      const password = encryptSha1(`${SECRET_SALT}${this.loginForm.password}${SECRET_SALT}`);
      const loginData = {
        mobile: this.loginForm.mobile,
        password,
        projectId: this.loginForm.projectId,
      };

      const loginResponse = await this.$axios.post<{
        code: number;
        admin: UserLogin;
      }>(postAdminLogin, loginData);

      if (loginResponse.data.code === 0) {
        const userModule = getModule(UserModule, this.$store);

        // set token
        userModule.setUser(loginResponse.data.admin);
        this.$cookie.set(getCookieName('token'), loginResponse.data.admin.token);

        // set user data
        const userData = loginResponse.data.admin;
        delete userData.token;
        this.$cookie.set(getCookieName('admin'), userData);

        // redirect
        const redirectPath = this.$route.query && this.$route.query.redirect
          ? (this.$route.query.redirect as string)
          : {
            name: 'home',
          };

        this.setApiPending();
        this.$router.push(redirectPath);
      } else {
        this.apiErrorCodeAlert(loginResponse.data.code, '登入', {
          102: '手機號碼或密碼錯誤。',
          4: '登入時發生錯誤。',
          5: '登入時發生錯誤。',
        });
      }
    } catch (error) {
      this.$notify.show('error filled',
        `${error.message ? error.message : '登入時發生錯誤。'}${error.status ? `(Code: ${error.status ? '' : ''})` : ''}`,
        '登入',
        { duration: 3000, permanent: false });
      console.error(error);
    }
    this.setApiPending();
  }
}
